import { MenuFooter } from '@r-and-a-shared-ui/common-ui';
import { kontentAiDataMapping } from '@r-and-a-shared-ui/core-data-mapping';

import type { MEMBERSHIP_MODELS } from '@r-and-a-shared-ui/common-kontent-client';
export default {
    component: () => MenuFooter,
    mapEntryToProps: (entry: MEMBERSHIP_MODELS.MenuFooter) =>
        kontentAiDataMapping.menu_footer(entry),
};
